<template>
  <div class="content">
    <el-drawer
      :title="$t('container.notice')"
      :visible.sync="drawer"
      :before-close="handleClose1"
      size="30%"
    >
      <div v-if="list.length > 0">
        <div
          v-for="(item, index) in list"
          :key="index"
          @click="showMessageDetail(item.Id)"
        >
          <el-card
            shadow="hover"
            class="messageBox"
            :class="item.IsRead === 1 ? 'isRead' : ''"
          >
            <div class="top" v-if="item.IsTop">{{ $t("container.top") }}</div>
            <h3>{{ item.Title }}</h3>
            <div>{{ item.MessageContent }}</div>
            <div class="time">
              <span>{{ item.ReleaseTime }}</span>
            </div>
          </el-card>
        </div>
        <div class="pages">
          <div class="btns">
            <p style="margin-right:20px;">
              {{
                $t("container.noticeText", {
                  number: count
                })
              }}
            </p>

            <el-button
              type="primary"
              round
              size="mini"
              style="margin-right:10px;"
              :disabled="page === 1"
              @click="previousPageAction"
              >{{ $t("container.previous") }}</el-button
            >
            <p style="margin-right:10px;">
              <span>{{ page }}</span>
              /{{ lastPage }}
            </p>
            <el-button
              type="primary"
              round
              size="mini"
              :disabled="page === lastPage || lastPage === 0"
              @click="nextPageAction"
              >{{ $t("container.next") }}</el-button
            >
          </div>
        </div>
      </div>
      <div v-else class="noMessage">
        <h3>{{ $t("container.noNotice") }}</h3>
      </div>
      <el-drawer
        :title="$t('container.noticeDetail')"
        append-to-body
        :visible.sync="innerDrawer"
        :before-close="handleClose2"
      >
        <el-card shadow="hover" class="messageBox">
          <h3>{{ messageDetail.Title }}</h3>
          <div>{{ messageDetail.MessageContent }}</div>
          <div class="time">
            <span>{{ messageDetail.ReleaseTime }}</span>
          </div>
        </el-card>
      </el-drawer>
    </el-drawer>

    <div class="bg" :class="{ bg1: imgBg }"></div>
    <div class="scroll-box" :class="{ 'no-scroll': imgBg }">
      <div
        class="switch"
        v-if="(supplierInfo.B2b2cMode || supplierInfo.B2bMode) && inPSPage()"
      >
        <el-button
          size="small"
          plain
          round
          @click="switchSupplierMode('/public')"
          v-if="inSupplier()"
          >{{ $t("container.switch1") }}</el-button
        >
        <el-button
          size="small"
          plain
          round
          @click="switchSupplierMode('/supplier')"
          v-else
          >{{ $t("container.switch2") }}</el-button
        >
      </div>
      <div
        class="nameAndLogout"
        v-if="name !== null && name !== '' && !isLoginPath"
      >
        <template v-if="inSupplier()">
          <figure class="userImgBox" @click="userManage">
            <img
              class="ImgIcon"
              :src="userImgUrl && getuserImgUrl(userImgUrl)"
              :onerror="errorImg"
              v-if="userImgUrl"
            />
            <img
              class="ImgIcon"
              src="@/assets/img/user/img_logo@2x.png"
              v-else
            />
          </figure>
          <span class="name">{{
            supplierInfo.CompanyName == null ? name : supplierInfo.CompanyName
          }}</span>
        </template>

        <span class="narbarBtn" @click="gotoBHome">{{
          $t("container.backHome")
        }}</span>

        <span class="narbarBtn" @click="logout">{{
          $t("container.logout")
        }}</span>

        <el-tooltip
          class="item"
          effect="dark"
          content="客服邮箱：service@vancheen.com"
          placement="bottom-end"
          v-if="inSupplier()"
        >
          <a class="narbarBtn" @click="contactService">{{
            $t("container.contactService")
          }}</a>
        </el-tooltip>

        <span class="narbarBtn" @click="openMessageBox">
          <el-badge :value="messagecount">{{
            $t("container.notice")
          }}</el-badge>
        </span>

        <span class="narbarBtn">
          <span @click="handleSetLanguage('en')" v-if="getLang() === 'zh'">
            English
          </span>
          <span @click="handleSetLanguage('zh')" v-else>
            中文
          </span>
        </span>
      </div>
      <div class="container">
        <slot></slot>
      </div>
    </div>

    <!-- 联系客服弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      center
    >
      <h3 style="margin-top:0px">{{ $t("container.serviceText") }}</h3>
      <el-select
        class="m-b-20"
        v-model="service.serviceType"
        :placeholder="$t('container.select')"
        style="width:100%"
      >
        <el-option
          v-for="item in serviceTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-input
        type="textarea"
        :placeholder="$t('container.inputContent')"
        :autosize="{ minRows: 4 }"
        v-model="service.serviceContent"
      ></el-input>
      <h3>{{ $t("container.contactWay") }}</h3>
      <el-input
        :placeholder="$t('container.inputEmail')"
        v-model="service.serviceEmail"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="serviceSubmit">{{
          $t("container.submit")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- 封禁窗口 -->
    <el-dialog
      class="bandBox"
      :visible.sync="bandVisible"
      min-width="50%"
      top="35vh"
      :center="true"
    >
      <div slot="title" class="title">{{ $t("container.bandTitle") }}</div>
      <div class="stateInfo">{{ $t("container.bandContent") }}</div>
      <div class="btns">
        <el-button
          class="stateInfoBt"
          type="success"
          @click="bandVisible = false"
          round
          >{{ $t("container.close") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LOG_OUT, SET_AUTH } from "../store/mutation-types";
export default {
  name: "container",
  props: {
    imgBg: {
      type: Boolean,
      default: false,
      isLoginPath: true
    }
  },
  data() {
    return {
      bandVisible: false,
      page: 1,
      count: 0,
      lastPage: 0,
      serviceTypeList: [
        { value: "1", label: this.$t("container.sOption1") },
        { value: "2", label: this.$t("container.sOption2") },
        { value: "3", label: this.$t("container.sOption3") }
      ],
      service: {
        serviceType: "", //服务类型
        serviceContent: "", //服务内容
        serviceEmail: "" //邮箱地址
      },
      dialogVisible: false, //联系客服弹窗
      innerDrawer: false,
      drawer: false,
      direction: "rtl",
      messageCount: null,
      list: [
        { message: this.$t("container.rOption1"), time: "2021-10-13 10:40" },
        { message: this.$t("container.rOption2"), time: "2021-10-13 10:40" },
        { message: this.$t("container.rOption3"), time: "2021-10-13 10:40" },
        { message: this.$t("container.rOption4"), time: "2021-10-13 10:40" },
        { message: this.$t("container.rOption5"), time: "2021-10-13 10:40" }
      ],
      messageDetail: { Title: "", MessageContent: "", ReleaseTime: "" },
      name:
        localStorage.getItem("auth") && this.$store.getters.isLogging
          ? JSON.parse(localStorage.getItem("auth")).userName
          : null,
      errorImg:
        'this.src="' + require("@/assets/img/user/img_logo@2x.png") + '"'
    };
  },
  watch: {},
  beforeCreate() {
    // console.log(this.$route.path)
    if (this.$route.path === "/login") {
      this.isLoginPath = true;
    } else {
      this.isLoginPath = false;
    }
  },
  computed: {
    ...mapState({
      userImgUrl: state => state.supplier.supplierInfo.HeadPhoto,
      supplierInfo: state => state.supplier.supplierInfo,
      messagecount: state => state.supplier.messageCount
    })
  },
  created() {
    this.getMessageCount();
  },
  mounted() {
    if (this.supplierInfo && this.supplierInfo.IsDel == 1) {
      this.bandVisible = true;
    }
  },
  methods: {
    ...mapMutations([LOG_OUT, SET_AUTH]),
    ...mapActions(["getMessageCount", "setLanguage"]),
    getLang() {
      return this.$store.getters.getLanguage;
    },
    handleSetLanguage(lang) {
      this.setLanguage(lang);
      location.reload();
      if (lang == "en") {
        this.$message({
          message: "Switch Language Success",
          type: "success"
        });
      } else {
        this.$message({
          message: "切换语言成功",
          type: "success"
        });
      }
    },
    inSupplier() {
      if (this.$route.path.includes("/supplier")) {
        return true;
      } else {
        return false;
      }
    },
    inPSPage() {
      if (
        this.$route.path.includes("/supplier") ||
        this.$route.path.includes("/public")
      ) {
        return true;
      } else {
        return false;
      }
    },
    isLogin() {
      return this.$store.getters.isLogging;
    },
    logout() {
      this.LOG_OUT();
      this.gotoBHome();
    },
    gotoHome() {
      this.$router.replace("/home");
    },
    gotoBHome() {
      this.$router.replace("/");
    },
    userManage() {
      if (this.supplierInfo.B2b2cMode || this.supplierInfo.B2bMode) {
        this.$route.path !== "/supplier/UserManage" &&
          this.$router.replace("/supplier/UserManage");
      } else {
        this.notify(this.$t("container.infoError"));
      }
    },
    switchSupplierMode(page) {
      var auth = JSON.parse(localStorage.getItem("auth")) || {};
      auth.UserName = auth.userName;
      auth.Ticket = auth.token;
      auth.Type = auth.type;

      var switchMode = 1;
      if (auth.userMode == 1) {
        switchMode = 2;
      } else {
        switchMode = 1;
      }

      let param = {
        SystemCurrentUseMode: switchMode
      };
      this.$api.customer
        .switchSupplierMode(param)
        .then(() => {
          auth.UserMode = switchMode;
          this.SET_AUTH(auth);
          this.$router.replace(page);
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    getuserImgUrl(userImgUrl) {
      return this.$api.formatImageUrl(userImgUrl);
    },
    //获取公告列表
    getPlatformMessage(page) {
      let param = {
        ReceipType: "SU",
        UserId: JSON.parse(localStorage.getItem("supplierInfo")).UserId,
        PageIndex: page,
        PageSize: 5
        // UserId:0
      };
      this.$api.system
        .getPlatformMessage(param)
        .then(res => {
          console.log(res, "res");
          this.list = res.data;
          this.lastPage = res.meta.lastPage;
          this.page = res.meta.page;
          this.count = res.meta.total;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    // 打开抽屉
    openMessageBox() {
      this.drawer = true;
      this.getPlatformMessage(this.page);
    },
    // 获取公告详情
    showMessageDetail(id) {
      this.innerDrawer = true;
      console.log(id, "id");
      let param = {
        ReceipType: "SU",
        MessageId: id,
        UserId: JSON.parse(localStorage.getItem("supplierInfo")).UserId
      };
      this.$api.system
        .getPlatformMessageDetail(param)
        .then(res => {
          console.log(res, "detail");
          this.messageDetail = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 关闭外部抽屉
    handleClose1(done) {
      done();
      this.getMessageCount();
    },
    // 关闭内部抽屉
    handleClose2(done) {
      done();
      this.getPlatformMessage(this.page);
    },
    // 弹窗关闭函数
    handleClose(done) {
      this.initServiceObj();
      done();
    },
    // 提交
    serviceSubmit() {
      if (
        this.service.serviceType == "" ||
        this.service.serviceContent == "" ||
        this.service.serviceEmail == ""
      ) {
        this.$message.error(this.$t("container.submitError"));
        return false;
      } else {
        this.dialogVisible = false;
      }
    },
    // 初始化表单
    initServiceObj() {
      for (let i in this.service) {
        this.service[i] = "";
      }
    },
    // 联系客服
    contactService() {
      this.$router.push({
        path: "/contactCustomerService",
        query: {
          Type: "SU"
        }
      });
    },
    notify(message) {
      this.$notify({
        title: "提示",
        message: message,
        type: "warning",
        duration: 3000
      });
    },
    // 下一页
    nextPageAction() {
      this.getPlatformMessage(this.page + 1);
    },
    // 上一页
    previousPageAction() {
      this.getPlatformMessage(this.page - 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.pages {
  margin-top: 30px;
  height: 30px;
  width: 100%;
  .btns {
    // width: 150px;
    display: flex;
    height: 30px;
    align-items: center;
    float: right;
    margin-right: 10px;
  }
}
.noMessage {
  display: flex;
  justify-content: center;
  color: #22b196;
}
.m-b-10 {
  margin-bottom: 10px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.content {
  height: 100%;
}
::v-deep .el-drawer__body {
  overflow: auto;
}
::v-deep.el-drawer__container ::-webkit-scrollbar {
  display: none;
}
.scroll-box {
  height: 100%;
  padding-top: 90px;
  padding-bottom: 90px;
  overflow: hidden;
  overflow-y: scroll;
}
.no-scroll {
  height: auto;
  overflow: initial;
  overflow-y: initial;
  .switch {
    position: absolute;
    margin-top: -2.8rem;
    left: 6%;
    color: #ffffff;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -moz-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
  }
  .nameAndLogout {
    position: absolute;
    min-height: 47px;
    top: 4%;
    right: 12%;
    color: #ffffff;
    display: flex;
    display: -webkit-flex;
    display: -ms-flex;
    display: -moz-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    .name {
      padding-right: 25px;
      border-right: 1px solid #fff;
      border-width: 2px;
    }
    .narbarBtn {
      margin-left: 25px;
      cursor: pointer;
      ::v-deep .el-badge__content {
        height: 20px;
        width: 20px;
        padding: 0px;
      }
    }
    .narbarBtn {
      text-decoration: none;
      &:link {
        text-decoration: none;
      }
      &:visited {
        text-decoration: none;
      }
      &:hover {
        text-decoration: none;
      }
      &:active {
        text-decoration: none;
      }
      &:focus {
        text-decoration: none;
      }
    }
    .userImgBox {
      margin: 0;
      padding: 0;
      margin-right: 15px;
      .ImgIcon {
        width: 2.7rem;
        height: 2.7rem;
        line-height: 2.7rem;
        border-radius: 100%;
        object-fit: cover;
        box-shadow: 0 0 5px 0 #25b9ff;
        -webkit-box-shadow: 0 0 5px 0 #25b9ff;
        cursor: pointer;
      }
    }
  }
}
.bg {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: linear-gradient(#71d284, #02aaa4);
  z-index: -99;

  &.bg1 {
    background-image: url("../assets/img/img_bg.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0 -500px;
    min-height: 700px;
    position: absolute;
  }
}

.container {
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  background-color: white;
  min-height: 100%;
  border-radius: 20px;
  position: relative;
  box-shadow: 0 0 50px 0 rgba(103, 182, 206, 0.27);
  overflow: hidden;
}
.isRead {
  background-color: #f1f3f4;
}
.messageBox {
  position: relative;
  width: 99%;
  margin-top: 10px;
  border-radius: 8px;
  min-height: 150px;
  cursor: pointer;

  .time {
    position: absolute;
    bottom: 5px;
    right: 10px;
    display: flex;
    justify-content: flex-end;
  }
  .top {
    position: absolute;
    top: 0px;
    right: 0px;
    height: 20px;
    border-radius: 8px;
    background-color: red;
    color: white;
    text-align: center;
    // font-weight: bold;
    width: 12%;
    font-size: 13px;
    line-height: 20px;
  }
}

.bandBox {
  text-align: center;
  ::v-deep .el-dialog--center {
    border-radius: 16px;
  }
  .stateInfo {
    margin: 0 auto;
    max-width: 800px;
    font-weight: bold;
    cursor: pointer;
    color: #ff5852;
    font-size: 18px;
    text-indent: 1em;
    text-align: center;
  }
  .stateInfoBt {
    margin: 0 auto;
    text-align: center;
    background-color: #22b196;
    font-weight: 500;
  }
  .btns {
    width: 100%;
    text-align: center;
    margin-top: 5%;
  }
  .title {
    font-weight: bold;
    font-size: 20px;
  }
}

@media (min-width: 1576px) {
  .container {
    max-width: 1540px;
  }
}

@media (min-width: 1768px) {
  .container {
    max-width: 1720px;
  }
}

@media (min-width: 1992px) {
  .container {
    max-width: 1960px;
  }
}

@media (min-width: 2200px) {
  .container {
    max-width: 2140px;
  }
}

@media (min-width: 2920px) {
  .container {
    max-width: 2720px;
  }
}
</style>
